import { useState } from "react";
import { useApp } from "@/store/AppStore";

const DataManagement = () => {
  const { loadDemo, data } = useApp();
  const [feedback, setFeedback] = useState("");

  const notify = (msg: string) => {
    setFeedback(msg);
    setTimeout(() => setFeedback(""), 2400);
  };

  const isEmpty =
    data.products.length === 0 &&
    data.clients.length === 0 &&
    data.sales.length === 0;

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-8 h-8 rounded-md bg-secondary-500/25 text-secondary-200 flex items-center justify-center">
          <i className="ri-settings-5-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Gestión de datos de la plataforma</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-4">
        La plataforma arranca limpia, sin datos de relleno. Puedes cargar una demostración para
        explorar el sistema cuando esté vacía. Para borrar datos, usa el{" "}
        <strong className="text-foreground-800">borrado por categoría</strong> de arriba.
      </p>

      <button
        onClick={() => {
          loadDemo();
          notify("Datos de demostración cargados.");
        }}
        disabled={!isEmpty}
        className={`px-4 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap inline-flex items-center justify-center gap-2 ${
          isEmpty
            ? "bg-accent-500 hover:bg-accent-600 text-background-50 cursor-pointer"
            : "bg-background-300/40 text-foreground-500 cursor-not-allowed"
        }`}
        title={isEmpty ? "Cargar demostración" : "Solo disponible con la plataforma vacía"}
      >
        <i className="ri-magic-line" /> Cargar datos de demostración
      </button>

      {feedback && (
        <p className="text-[11px] text-accent-200 mt-3 flex items-center gap-1.5 animate-fade-up">
          <i className="ri-checkbox-circle-line" /> {feedback}
        </p>
      )}
    </div>
  );
};

export default DataManagement;